import axios from 'axios'
import { SALVAR_IMAGENS_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function salvarImagensEncomenda (idEncomenda, idEmpresa, imagens) {
  const url = `${URL}/encomendas/${idEncomenda}/empresa/${idEmpresa}/imagens`;
  return dispatch => axios.post(url, imagens, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: SALVAR_IMAGENS_ENCOMENDA,
        payload: response
      })
  );
}